<template>
  <component
    :is="blockTypeComponent"
    :block="block"
    :step="step"
    v-on:delete="deleteItem()"
    @refresh="this.$emit('change')"
    @up="up()"
    @down="down()"
  />
</template>

<script>
import axios from "axios";
export default {
  name: "block",
  components: {
    BlockField: () => import("./blocks/Field"),
    BlockFieldGroup: () => import("./blocks/FieldGroup")
  },
  props: {
    block: {
      type: Object,
      required: true
    },
    step: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    blocks: [],
    conditionForm: false
  }),
  computed: {
    blockTypeComponent: function() {
      if (this.block.type_id == "field") {
        return "BlockField";
      } else {
        return "BlockFieldGroup";
      }
    },
    blockType: function() {
      if (this.block.type_id == "field") {
        return "Field";
      } else {
        return "Field Group";
      }
    }
  },

  mounted: function() {},
  methods: {
    async getBlocks() {
      await axios
        .get(
          "service/" +
            this.ste.services_id +
            "/step/" +
            this.step.id +
            "/block/" +
            this.block.id
        )
        .then(response => (this.blocks = response.data));
    },
    async up() {
      await axios
        .put(
          "service/" +
            this.step.services_id +
            "/step/" +
            this.step.id +
            "/block/" +
            this.block.id +
            "/up"
        )
        .then(() => this.$emit("change"));
    },
    async down() {
      await axios
        .put(
          "service/" +
            this.step.services_id +
            "/step/" +
            this.step.id +
            "/block/" +
            this.block.id +
            "/down"
        )
        .then(() => this.$emit("change"));
    },
    async deleteItem() {
      this.$store
        .dispatch("services/deleteBlock", {
          step: this.step,
          block: this.block
        })
        .then(() => this.$emit("change"));
    }
  }
};
</script>

<style lang="scss" scoped>
.step {
  box-shadow: 2px 2px 4px 2px #00000024;
  .header {
    padding: 10px 10px;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      171deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(245, 245, 245, 1) 53%,
      rgba(244, 244, 244, 1) 100%
    );
    border-bottom: 1px solid #cccccc7d;
  }
  .content {
    display: flex;
    .blocks {
      flex: 1 1 90%;
    }
    .actions {
      flex: 0 0 5%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #efefef;
      ul {
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        li {
          list-style: none;
        }
      }
    }
  }
}
</style>
